import { render } from "./ImageProcess.vue?vue&type=template&id=cb6f6302&scoped=true&ts=true"
import script from "./ImageProcess.vue?vue&type=script&lang=ts"
export * from "./ImageProcess.vue?vue&type=script&lang=ts"

import "./ImageProcess.vue?vue&type=style&index=0&id=cb6f6302&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6f6302"]])

export default __exports__